import loadSearchModule from './modules/Search.module';
const loadMenuSearchModule = () => ({
    hasRouter: false,
    modules: [loadSearchModule()],
});
export default loadMenuSearchModule;
